import React from 'react';
import './tailwind.output.css';
import './App.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from 'react-router-dom';
import Home from './pages/Home';
import bgImage from './utils/images/background.jpg';
import Projects from './pages/Projects';
import Experience from './pages/Experience';
import Contact from './pages/Contact';

const App = () => {
    return (
        <Router>
            <Switch>
                <Route path="/projects" exact component={Projects} />
                <Route path="/experience" exact component={Experience} />
                <Route path="/contact" exact component={Contact} />
                <Route path="/" exact component={Home} />
                <Redirect to="/" />
            </Switch>

            <img
                style={{
                    backgroundImage: `url(${bgImage})`,
                    backgroundRepeat: 'no-repeat',
                    zIndex: -10,
                    position: 'fixed',
                }}
                alt=""
                className="top-0 w-screen h-screen bg_image bg-cover"
            />
        </Router>
    );
};

export default App;
